'use strict';

angular.module('utils').factory('OCHoursUtil', function() {
  var self = {
    isEmptyHours: function(hours) {
      for (var i = 0; i < hours.length; i++) {
        if (hours[i].start || hours[i].end) {
          return false;
        }
      }
      return true;
    },

    isDayValid: function(hours, index) {
      var hoursForDay = hours[index];
      return (
        (hoursForDay.start === 0 && hoursForDay.end === 0) // Closed
        || (hoursForDay.end >= hoursForDay.start && !!hoursForDay.start)
      );
    },

    hasInvalidDay: function(hours) {
      for (var i = 0; i < 7; i++) {
        if (!this.isDayValid(hours, i)) {
          return true;
        }
      }
      return false;
    },

    hoursDropdownOptions: function() {
      var hours = ['12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
      var minutes = ['00', '15', '30', '45'];
      var meridians = ['AM', 'PM'];

      var times = [];
      for (var h = 0; h < meridians.length; h++) {
        for (var i = 0; i < hours.length; i++) {
          for (var j = 0; j < minutes.length; j++) {
            times.push({
              label: hours[i] + ':' + minutes[j] + ' ' + meridians[h],
              value: i * 60 + j * 15 + (h === 1 ? 720 : 0), // hh:mm:pm? -> minutes past midnight, plus PM
            });
          }
        }
      }
      return times;
    },
  };

  return self;
});
